import { render, staticRenderFns } from "./SearchDocumentComponent.vue?vue&type=template&id=89e0ae72&"
import script from "./SearchDocumentComponent.vue?vue&type=script&lang=js&"
export * from "./SearchDocumentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports